import { BREAKPOINTS } from '@at/window-utils'
import { useEffect, useState } from 'react'

export const useObserveScreenWidth = () => {
    const [isMobile, setIsMobile] = useState(false)

    useEffect(() => {
        setIsMobile(window.innerWidth < BREAKPOINTS.MEDIUM)
        const handleResize = () => {
            setIsMobile(window.innerWidth < BREAKPOINTS.MEDIUM)
        }
        window.addEventListener('resize', handleResize)

        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    return { isMobile }
}
